let env
if (window && window.ua && window.ua.indexof('MicroMessage') == -1) {
  //说明不在微信中
  env = 'h5'
} else {
  if (typeof getApp === 'function') {
    env = 'weApp'
  } else {
    // 不在小程序
    env = 'other'
  }
}
export default env
